// src/store/actions/blogPostActions.js
import { BLOG_POST_ACTIONS } from './actionTypes';
import blogPostService from '../../services/blogPostService';

// Fetch blog posts
export const fetchBlogPosts = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_POSTS_REQUEST });

    const response = await blogPostService.getBlogPosts(params);
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_POSTS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_POSTS_FAILURE,
      payload: error.message || 'Failed to fetch blog posts',
    });
  }
};

// Fetch single blog post
export const fetchBlogPost = (id) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_POST_REQUEST });

    const response = await blogPostService.getBlogPostById(id);
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_POST_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_POST_FAILURE,
      payload: error.message || 'Failed to fetch blog post',
    });
    throw error;
  }
};

// Create blog post
export const createBlogPost = (postData) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.CREATE_BLOG_POST_REQUEST });

    const response = await blogPostService.createBlogPost(postData);
    
    dispatch({
      type: BLOG_POST_ACTIONS.CREATE_BLOG_POST_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.CREATE_BLOG_POST_FAILURE,
      payload: error.message || 'Failed to create blog post',
    });
    throw error;
  }
};

// Update blog post
export const updateBlogPost = (id, postData) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_REQUEST });

    const response = await blogPostService.updateBlogPost(id, postData);
    
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_FAILURE,
      payload: error.message || 'Failed to update blog post',
    });
    throw error;
  }
};

// Delete blog post
export const deleteBlogPost = (id) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.DELETE_BLOG_POST_REQUEST });

    const response = await blogPostService.deleteBlogPost(id);
    
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_BLOG_POST_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_BLOG_POST_FAILURE,
      payload: error.message || 'Failed to delete blog post',
    });
    throw error;
  }
};

// Update blog post status
export const updateBlogPostStatus = (id, status) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_STATUS_REQUEST });

    const response = await blogPostService.updateBlogPostStatus(id, status);
    
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_STATUS_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_BLOG_POST_STATUS_FAILURE,
      payload: error.message || 'Failed to update blog post status',
    });
    throw error;
  }
};

// Fetch blog comments
export const fetchBlogComments = (postId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_COMMENTS_REQUEST });

    const response = await blogPostService.getBlogComments(postId, params);
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_COMMENTS_SUCCESS,
      payload: { postId, ...response },
    });
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_COMMENTS_FAILURE,
      payload: error.message || 'Failed to fetch comments',
    });
  }
};

// Update comment status
export const updateCommentStatus = (postId, commentId, status) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.UPDATE_COMMENT_STATUS_REQUEST });

    const response = await blogPostService.updateCommentStatus(postId, commentId, status);
    
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_COMMENT_STATUS_SUCCESS,
      payload: { commentId, status, data: response.data },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.UPDATE_COMMENT_STATUS_FAILURE,
      payload: error.message || 'Failed to update comment status',
    });
    throw error;
  }
};

// Delete comment
export const deleteComment = (postId, commentId) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.DELETE_COMMENT_REQUEST });

    const response = await blogPostService.deleteComment(postId, commentId);
    
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_COMMENT_SUCCESS,
      payload: { commentId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_COMMENT_FAILURE,
      payload: error.message || 'Failed to delete comment',
    });
    throw error;
  }
};

// Fetch blog categories
export const fetchBlogCategories = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_CATEGORIES_REQUEST });

    const response = await blogPostService.getBlogCategories(params);
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_CATEGORIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_CATEGORIES_FAILURE,
      payload: error.message || 'Failed to fetch categories',
    });
  }
};

// Fetch blog tags
export const fetchBlogTags = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_TAGS_REQUEST });

    const response = await blogPostService.getBlogTags(params);
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_TAGS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_TAGS_FAILURE,
      payload: error.message || 'Failed to fetch tags',
    });
  }
};

export const deleteBlogPostDocument = (postId, documentId) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.DELETE_DOCUMENT_REQUEST });

    const response = await blogPostService.deleteDocument(postId, documentId);
    
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_DOCUMENT_SUCCESS,
      payload: { documentId, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.DELETE_DOCUMENT_FAILURE,
      payload: error.message || 'Failed to delete document',
    });
    throw error;
  }
};

// Upload featured image
export const uploadFeaturedImage = (postId, file) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.UPLOAD_FEATURED_IMAGE_REQUEST });

    const response = await blogPostService.uploadFeaturedImage(postId, file);
    
    dispatch({
      type: BLOG_POST_ACTIONS.UPLOAD_FEATURED_IMAGE_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.UPLOAD_FEATURED_IMAGE_FAILURE,
      payload: error.message || 'Failed to upload featured image',
    });
    throw error;
  }
};

// Bulk delete blog posts
export const bulkDeleteBlogPosts = (ids) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.BULK_DELETE_BLOG_POSTS_REQUEST });

    const response = await blogPostService.bulkDeleteBlogPosts(ids);
    
    dispatch({
      type: BLOG_POST_ACTIONS.BULK_DELETE_BLOG_POSTS_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.BULK_DELETE_BLOG_POSTS_FAILURE,
      payload: error.message || 'Failed to bulk delete blog posts',
    });
    throw error;
  }
};

// Get blog statistics
export const fetchBlogStats = () => async (dispatch) => {
  try {
    dispatch({ type: BLOG_POST_ACTIONS.FETCH_BLOG_STATS_REQUEST });

    const response = await blogPostService.getBlogStats();
    
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: BLOG_POST_ACTIONS.FETCH_BLOG_STATS_FAILURE,
      payload: error.message || 'Failed to fetch blog stats',
    });
  }
};

// Set blog post filters
export const setBlogPostFilters = (filters) => ({
  type: BLOG_POST_ACTIONS.SET_BLOG_POST_FILTERS,
  payload: filters,
});

// Clear error
export const clearBlogPostError = () => ({
  type: BLOG_POST_ACTIONS.CLEAR_BLOG_POST_ERROR,
});

// Clear success
export const clearBlogPostSuccess = () => ({
  type: BLOG_POST_ACTIONS.CLEAR_BLOG_POST_SUCCESS,
});

// Clear selected blog post
export const clearSelectedBlogPost = () => ({
  type: BLOG_POST_ACTIONS.CLEAR_SELECTED_BLOG_POST,
});